import { Card, CardContent, Checkbox, TextField, Typography } from "@mui/material";
import { getDataSource } from "api/ds";
import Loading from "components/Load";
import { ReportTable } from "components/reportTable";
import Scrollbars from "rc-scrollbars";
import { useEffect, useMemo, useRef, useState } from "react";
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from '@mui/icons-material/Close';
import ClassicSearch from "components/classicSearch";

export default function ProductStocks ({ data, load }){

    const [loading, setLoading] = useState(load);
    
    //Настройки Фильтра
    const [checked, setChecked] = useState(false);
    const [filter, setFilter] = useState(null);
    const [filterFields, setFilterFields] = useState(
        {
            title: {name: "Название", active: true},
            brand: {name: "Брэнд", active: true},
            vendorCode: {name: "Артикул", active: true},
            barcode: {name: "ШК", active: true},
        }
    );

    const [changeData, setChangeData] = useState([]);

    const change = (data) => {
        let changedData = JSON.parse(JSON.stringify(data || []));
        let changedDataFinal = changedData;
        let storageArray = []
        let sizesArray = []
        let roadArray = []
        let countArray = []

        if(data && data.length > 0 && data[0].countOnSizes.stocks){
            let combined = []
            let sortedComb = []
            for(let i = 0; i < data.length; i++){
                countArray = data[i].countOnSizes.stocks
                roadArray = data[i].inRoadOnSizes.stocks
                storageArray = data[i].storageOnSize.stocks
                sizesArray = data[i].sizes.items

                combined = storageArray.map((value, index) => ({
                    storage: value.stocks, 
                    count: countArray?.[index]?.stocks ?? 0,
                    road: roadArray?.[index]?.stocks ?? 0,
                    sizes: sizesArray?.[index] ?? 0}));
                sortedComb = combined.sort((a, b) => {
                    if (b.storage !== a.storage) {
                        return b.storage - a.storage;}
                    if (b.count !== a.count) {
                        return b.count - a.count;}
                    return b.road - a.road;
                });

                console.log('SORTED', sortedComb)
                console.log('CHANGE DATA', data[i].storageOnSize)

                for(let j = 0; j < sortedComb.length; j++){
                    changedData[i].countOnSizes.stocks[j].stocks = sortedComb[j].count
                    changedData[i].inRoadOnSizes.stocks[j].stocks = sortedComb[j].road
                    changedData[i].storageOnSize.stocks[j].stocks = sortedComb[j].storage
                    changedData[i].sizes.items[j] = sortedComb[j].sizes
                }

            }

            changedDataFinal = changedData.sort((a, b) => {
                const totalA = a.storageOnSize?.total ?? 0; 
                const totalB = b.storageOnSize?.total ?? 0;
                return totalB - totalA; 
            });
        }
        setChangeData(changedDataFinal);
    };

    useEffect(() => {
        change(data)
    }, [data]);

    useEffect(() => {
        console.log("Load", load)
        setLoading(load)
    }, [load]);

    const ds = useMemo(() => getDataSource('ProductTotalCount'), []);
    
    console.log("data, PS", data)

    return(
    <Card sx={{ borderRadius: 3, boxShadow: 5 }}>
        <CardContent>
            <Typography variant="h3" style={{ marginBottom: 15 }} >{`Кол-во товара на складах`}</Typography>
            <ClassicSearch 
                setChecked={setChecked} 
                setFilter={setFilter} 
                checked={checked}
                fields={filterFields}
                setFields={setFilterFields}
            />
            <Scrollbars
                autoHeight autoHeightMin={420} autoHeightMax={420}
            >
                {loading? <Loading></Loading>: 
                    <ReportTable
                        ds={ds}
                        data={!checked? changeData: changeData.filter((el) => {const tf = filter.toLowerCase(); 
                            return (
                                filterFields.title.active &&
                                    el.data.title &&
                                    String(el.data.title).toLowerCase().includes(tf) || 
                                filterFields.brand.active &&
                                    el.data.brand &&
                                    String(el.data.brand).toLowerCase().includes(tf) || 
                                filterFields.vendorCode.active &&
                                    el.data.vendorCode &&
                                    String(el.data.vendorCode).toLowerCase().includes(tf) ||
                                filterFields.barcode.active &&
                                    el.data.sizes && 
                                    el.data.sizes.filter((fel) => String(fel.barcode).toLowerCase().includes(tf)).length>0
                            )})}
                    />             
                }

            </Scrollbars> 
        </CardContent>
    </Card>
    );
};